import React, { Component } from "react";
import { getDateAsMonthYear } from '../helpers/helpers';


class LightboxImage extends Component {
  constructor(props) {
    super(props);

    this.photo = this.props.info;
  }

  // Get the caption, which includes the date
  getCaption() {
     return "Photo from " + getDateAsMonthYear(this.photo.mediaDate);
  }

  render() {
    return (
      <div className="lightbox__item">
        <img className="" src={this.photo.url} alt="" />
        <div className="lightbox__info">
          <p className="lightbox__caption">{this.getCaption()}</p>
          {this.photo.captionForSupporter ? (
            <p className="lightbox__description">{this.photo.captionForSupporter}</p>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default LightboxImage;
